import { Navigate, Outlet } from 'react-router-dom'
import { getToken, getTokenMember } from '../utils/app.utils';


interface authenticationProps {
    isAccept: boolean;
}
const PrivateRoute = ({ is_member }: { is_member?: boolean }) => {
    // อ่าน token ทุกครั้งที่ render ไม่ใช่ครั้งเดียวตอน import
    // ไม่งั้น route guard จะใช้ค่า token เก่าเมื่อ navigate แบบ SPA (ไม่ reload)
    const token = getToken();
    const token_member = getTokenMember();
    let auth: authenticationProps = { isAccept: is_member ? !!token_member : !!token };

    return (
        auth.isAccept ? <Outlet /> : (is_member ? <Navigate to="/login-member" /> : < Navigate to="/login" />)
    )
}

export default PrivateRoute
